import styled from 'styled-components';

import { Box } from 'components/Box/Box';
import { namedBreakpoints } from 'theme';

export const BannerAdsBox = styled(Box)`
  @media screen and (max-width: ${namedBreakpoints.mdDown}) {
    display: none;
  }

  @media print {
    display: none;
  }
`;
